import useToastStatus from '@/components/toastStatusGlobal';
import { COMPANY_CONFIG_NAME } from '@/modules/company/entities/enums/company';
import { ParamsToFilterCompanies } from '@/modules/company/entities/interfaces/company';
import CompaniesService from '@/modules/company/services/companiesService';
import { DigitalHospitalSteps } from '@/modules/companyDigitalHospitalConfig/entities/enums/digitalHospital.enums';
import { ListParams } from '@/modules/companyDigitalHospitalConfig/entities/interfaces/digitalHospital.interfaces';
import { useRequestCreation } from '@/shared/hooks/useRequestData/useRequestCreation';
import { cloneDeep } from 'lodash';

const { REACT_APP_COMPANY_DIGITAL_HOSPITAL_CONFIG_VALUE } = process.env;

interface UseDigitalHospitalRequests {
  requestCallback?: () => void;
}

export const useDigitalHospitalRequests = ({ requestCallback }: UseDigitalHospitalRequests) => {
  const { toast } = useToastStatus();

  const { loading: saving, requestCreate: saveManyCompanyConfigs } = useRequestCreation({
    request: (companyIds: string[]) =>
      new CompaniesService().saveManyCompanyConfigs(
        companyIds.map((companyId) => ({
          companyId,
          name: COMPANY_CONFIG_NAME.DIGITAL_HOSPITAL_INSIGHTS,
          value: REACT_APP_COMPANY_DIGITAL_HOSPITAL_CONFIG_VALUE,
        })),
      ),
    callback: () => {
      requestCallback?.();
      toast('Feito!', 'As empresas selecionadas agora têm acesso aos indicadores de hospital digital.', 'success');
    },
  });

  const { loading: deleting, requestCreate: deleteManyCompanyConfigs } = useRequestCreation({
    request: (companyIds: string[]) =>
      new CompaniesService().deleteManyCompanyConfigs(
        companyIds.map((companyId) => ({
          companyId,
          name: COMPANY_CONFIG_NAME.DIGITAL_HOSPITAL_INSIGHTS,
        })),
      ),
    callback: () => {
      requestCallback?.();
      toast(
        'Feito!',
        'Os indicadores de hospital digital não estão mais disponíveis para as empresas selecionadas.',
        'success',
      );
    },
  });

  const mountPayloadToSearch = (params: ListParams): Partial<ParamsToFilterCompanies> => {
    const { stepDigitalHospital, ...payload }: ListParams = cloneDeep(params);

    if (stepDigitalHospital === DigitalHospitalSteps.DISABLED) {
      payload.withoutConfig = COMPANY_CONFIG_NAME.DIGITAL_HOSPITAL_INSIGHTS;
    } else {
      payload['companyConfigs.name'] = COMPANY_CONFIG_NAME.DIGITAL_HOSPITAL_INSIGHTS;
    }

    return payload;
  };

  const getPaginatedList = async (params: ListParams) => {
    const payload = mountPayloadToSearch(params);
    return new CompaniesService().getCompanies(payload);
  };

  return { saving, deleting, saveManyCompanyConfigs, deleteManyCompanyConfigs, getPaginatedList };
};
